export default class DeviceDetector {
    static getDeviceType() {
        // Prüfe, ob Touch unterstützt wird:
        if (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) {
         return 'mobile';
        }
        
        // Überprüfe mittels Media Query:
        if (window.matchMedia && window.matchMedia("(pointer: coarse)").matches) {
            return 'mobile';
        }
        
        // Fallback: User Agent Überprüfung:
        const ua = navigator.userAgent;
        if (/Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
            return 'mobile';
        }
        
        return 'desktop';
    }
}